import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ImportedListingPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ImportedListingPageContainer" */
      './ImportedListingPageContainer.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
